<template>
  <div class="mask">
    <div class="maskA">
      <div class="maskAA">
        <p>{{title}}</p>
        <img @click="closemask" src="../../src/assets/img/cha.png" />
      </div>
      <div class="ANAN">
        <figure v-for="item in maskcontent">
          <figcaption>{{item}}</figcaption>
        </figure>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    props: {
      title: {
        type: String
      },
      maskcontent: {
        type: Array
      }
    },
    data() {
      return {
      }
    },
    methods: {
      closemask() {
        console.log(11123)
        this.$emit("close")
      },
    }
  }
</script>

<style scoped>
  /* 遮罩层  ↓ */
  .mask {
    width: 100vw;
    height: 100vh;
    position: fixed;
    top: 0;
    left: 0;
    z-index: 120;
    background-color: rgba(0, 0, 0, 0.7);
  }

  .maskA {
    width: 500px;
    min-height: 200px;
    background: rgb(255, 255, 255);
    border-radius: 20px;
    position: fixed;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    overflow: hidden;
  }

  .maskAA {
    width: 500px;
    height: 50px;
    background-image: url("../assets/img/zzctop.png");
    background-size: 100% 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding-right: 28px;
    padding-left: 28px;
    margin-bottom: 10px;
    box-sizing: border-box;
  }

  .maskAA img {
    width: 28px;
    height: 28px;
    cursor: pointer;
  }

  .ANAN {
    width: 100%;
    padding-bottom: 10px;
    padding-left: 50px;
    padding-right: 50px;
    padding-top: 20px;
    /* height: calc(100% - 170px); */

    /* height: 380px; */
  }

  .maskAA p {
    font-size: 20px;
    width: 500px;
    text-align: center;
    font-family: PingFang SC;
    font-weight: 500;
    color: #ffffff;
  }

  .ANAN figure {
    display: flex;
    margin-bottom: 18px;

  }

  .ANAN figure span {
    margin-right: 15px;
    background-color: #F44F25;
    display: flex;
    justify-content: center;
    align-items: center;
    color: white;
    font-size: 18px;
    border-radius: 15px;
    width: 25px;
    height: 25px;
  }

  .ANAN figure figcaption {
    text-indent: 1cm;
    font-size: 16px;
    /* line-height: 30px; */
    color: #F53824;
    font-family: PingFang SC;
    font-weight: 500;
  }

</style>



// WEBPACK FOOTER //
// src/components/mask.vue